import { Component, Input } from '@angular/core';
import { NavigationType } from '@shared-libs/enums';
import { AuthenticationService } from '@shared-services/authentication.service';
import { AppManager } from '@shared-managers/app.manager';
import { NavigationService } from '@shared-services/navigation.service';
import { INavigationRoute } from '@shared-libs/interfaces';
import { UserDetailsManager } from '@shared-managers/user-details.manager';
import { IUserDetails } from '@shared-models/user.model';
import { BehaviorSubject } from 'rxjs';

@Component({
	selector: 'navigation-desktop-component',
	templateUrl: 'navigation.desktop.component.html',
	styleUrls: ['./navigation.desktop.component.scss'],
})
export class NavigationDesktopComponent {
	@Input() public routes: Array<INavigationRoute>;

	public menuIsOpen: boolean;
	public userDetails: IUserDetails;
	public readonly userDetailsSubject: BehaviorSubject<IUserDetails>;
	public readonly role: string;
	public readonly notInProduction: boolean;
	public readonly environment: string;

	constructor(
		private readonly appManager: AppManager,
		public readonly authenticationService: AuthenticationService,
		private readonly navigationService: NavigationService,
		private readonly userDetailsManager: UserDetailsManager
	) {
		this.menuIsOpen = this.appManager.getMenuState() ?? true;
		this.userDetailsSubject = this.userDetailsManager.getUserDetails();
		this.notInProduction = this.appManager.isNotProduction();
		this.environment = this.appManager.getEnvironment();
		this.userDetailsSubject.subscribe((userDetails) => {
			this.userDetails = userDetails;
		});
	}

	public toggleButtonDescription(): void {
		this.menuIsOpen = !this.menuIsOpen;
		this.appManager.setMenuState(this.menuIsOpen);
	}

	public async navigateTo(url: string): Promise<void> {
		this.navigationService.resetNavigation();
		await this.navigationService.navigateTo(NavigationType.page, url);
	}

	public isActive(route: string): boolean {
		return this.navigationService.isActive(route);
	}
}
